import React, { useState } from 'react';
import { Box, FormControlLabel, Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Control, Controller, UseFormWatch } from 'react-hook-form';
import InfoDialog from 'components/InfoDialog';
import { SubDivisionFormValues } from '../containers/useSubDivisionContainer';

interface BumpoutTimesheetFieldProps {
  control: Control<SubDivisionFormValues>;
  watch: UseFormWatch<SubDivisionFormValues>;
  initialValue: boolean;
  disabled?: boolean;
}

export const BumpoutTimesheetField: React.FC<BumpoutTimesheetFieldProps> = ({
  control,
  watch,
  initialValue,
  disabled = false,
}) => {
  const classes = useStyles();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const currentValue = watch('reqBumpoutTimesheet');

  const isFieldDisabled = initialValue === true || disabled;

  return (
    <Box className={classes.container}>
      <Controller
        name="reqBumpoutTimesheet"
        control={control}
        render={({ field: { onChange, value, ref } }) => (
          <FormControlLabel
            control={
              <Switch
                checked={!!value}
                onChange={e => {
                  const newValue = e.target.checked;
                  onChange(newValue);
                  if (newValue && !currentValue) {
                    setIsConfirmModalOpen(true);
                  }
                }}
                inputRef={ref}
                color="primary"
                disabled={isFieldDisabled}
              />
            }
            label="Follow Bumpout Timesheets Flow"
          />
        )}
      />
      <InfoDialog
        title="Attention!"
        handleClose={() => setIsConfirmModalOpen(false)}
        open={isConfirmModalOpen}
        content="Activating this setting is a permanent change with no option to revert. All jobs will progress through the new bump flows if this change is made. Please be aware before saving."
      />
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    margin: '20px 15px',
  },
});

export default BumpoutTimesheetField;
